<template>
  <el-row class="vdr-parent">
    <!-- 联考信息 -->
    <div class="kl-title">
      <el-row>{{ this.$route.query.subject }}{{ this.$route.query.xm }}[{{ this.$route.query.tizu }}]</el-row>
    </div>

	<!-- 评分提示显示 -->
		<div  style="  z-index:12 ;height: 30px; width: 30px;  position: absolute;">
			<!-- 评分提示显示 -->
			<transition name="kl">
			<vue-draggable-resizable
				v-show="img_src!=''"
				:x="0"
				:y="0"
				:w="30"
				:h="30"
				:debug="false"
				:resizable="false"
				:z="11"
				class-name="kl-score-tisp"
			>
				{{ input }}
		
			</vue-draggable-resizable>
			</transition>
		</div>

    <!-- 加载试卷 -->
  	<div  class="imgdiv" :style="{ background: '#f2f2f2',height: '100%', width: screenWidth - 50 + 'px' }"> 	
					
		<div id="panzoom-element" z-index:-1  :style="{ background: '#f2f2f2',height: imgShowHeight - 10 + 'px', width: imgShowWidth + 'px' }"> 	
	
		
			<img 
      v-show="img_src!=''"
			ref="imgSize"						
			:src="img_src" 
			:style="{height: imgShowHeight - 10 + 'px', width: imgShowWidth  + 'px' }" 
			@load='justifyImgWidth($event)' 
			/>
	
		
		</div>	
	</div>	



    <!-- 评分功能操作栏 -->
    <div class="kl-numbar">
      <vue-draggable-resizable
        :x="0"
        :y="-70"
        :w="572"
        :h="60"
        :debug="false"
        :resizable="false"
        :drag-handle="'.drag-handle'"
        :z="10"
      >
        <!-- 评分键盘 -->
        <transition name="kl">
          <div
            v-show="visible"
            class="kl-score-keycode"
            :class="[maxKeycode ? 'kl-max-keycode klsk-in-up' : 'klsk-in-up', isFenbu ? 'ty-step-score': '']"
          >
            <el-button
              v-for="item, index in validFenZhiList"
              :key="index"
              plain
              :data-key="index"
              @click="keySave($event)"
            >{{item,scoreKb}}</el-button>

    
          </div>
        </transition>

  

        <!-- 异常按钮 -->
        <el-button type="danger" data-key="ycFn" :disabled="is_disable" plain @click="openYcFn()">异常</el-button>

        <!-- 回评功能 -->
        <el-button-group>
          <el-button data-key="Last" @click="backLast('Last')" @keyup.left.native="lastBtnFn">
            <i class="el-icon-arrow-left el-icon--left" />
            <span class="el-icon-t">上一份</span>
          </el-button>
           <el-button data-key="Next" @click="backLast('Next')" @keyup.right.native="nextBtnFn">
            <span class="el-icon-t">下一份</span>
            <i class="el-icon-arrow-right el-icon--right" />
          </el-button>
          <el-row>
             <span class="kl-exam-mark">
               <span>总数</span>/
              <span>{{ this.yjStatusView }}</span>
              
            </span>
            <span class="kl-exam-count">              
              <span v-text="blBtn ? this.allsj_count : this.blCount" />/
              <span>{{ this.yjcount }}</span>
            </span>
           
          </el-row>
         
        </el-button-group>

        <!-- 评分功能 -->
        <div
          class="el-input el-input--default el-input-group el-input-group--append el-input-group--prepend ty-score-bar"
          :class="{'ty-score-bar-btn':isFenbu}"
        >
          <div class="el-input-group__prepend">
            <el-button data-key="MiScore" @click="keycodeScore($event)">给分列表</el-button>
          </div>
          <el-input
            v-if="!isFenbu"
            v-model="input"
            v-focus="!isFenbu"
            :placeholder="'满分' + this.max_score"
            maxlength="4"
            @keyup.native="inputEnterFun"
          />
          <!-- 分步评分 -->
          <div v-else="isFenbu" class="ty-step-by">
            <input
              v-for="item, index in tihaoArray"
              :key="item.id"
              v-model="dataF[index]"
              class="ty-step-by-list"
              :placeholder="fenzhiArray[index]"
              maxlength="4"
              type="text"
              @keyup.native="inputEnterFun"
            >
          </div>
          <div class="el-input-group__append">
            <el-button data-key="Ent" :disabled="entFn" @click="scoreSave($event)">提交</el-button>
          </div>
        </div>
        <div class="drag-handle l" />
        <div class="drag-handle r" />
      </vue-draggable-resizable>
    </div>
  </el-row>
</template>

<script>
import keyboard from 'vue-keyboard'
import VueDraggableResizable from 'vue-draggable-resizable'
import Panzoom from '@panzoom/panzoom'

// 导入api接口
// import { markingSo } from '@/request/api';
// import { LoginCode } from '@/request/api';

export default {
    directives: {
    // 注册一个局部自定义指令 v-focus
    focus: {
      // 绑定判断
      inserted: function(el, { value }, index) {
        // 聚焦元素
        if (value) {
        //  el.querySelector('input').focus()
        } else {
        //  el.focus()
        }
      },
      // 更新判断
      update: function(el, { value }, index) {
        if (value) {
         // el.querySelector('input').focus()
        } else {
         // el.focus()
        }
      },
      // 更新完成
      componentUpdated: function(el, { value }, index) {}
    }
  },

  inject: ['reload'], //注入reload方法
  components: {
    keyboard
  },
  props: ['disabled'],
  data() {
    return {
      msg: 'Hello World!',
      loginmsg: 'loginmsg',
      username: '',
      password: '',
      sites: {},
      img: {},
      img_src: '',
      fit: 'contain',
      visible: false,
      dialogTableVisible: false,
      isCollapse: true,
      options: [],
      selectedOptions: [],
      selectedOptions2: [],
      input: '',
	  screenHeight: document.body.clientHeight - 80,
	  screenWidth: document.body.clientWidth-80,
      sel_xm: '',
      sel_sb: '',
      sel_tizu: '',
      max_score: 0,
      maxScore: [],
      buchang: 0,
      tihaoArray: [],
      fenzhiArray: [],
      dataF: [],
      scoreKb: [],
      isFenbu: false,
      loading: false,
      is_disable: false,
      as_disable: false,
      autoSave: false, // 自动 手动提交切换
      maxKeycode: false, // 显示大键盘
      entFn: true,
      blBtn: true, // 回评分值显示
      blCount: 0, // 回评总量
      yjcount: 0, // 阅卷量
      allsj_count: 0, // 阅卷任务量
	  yjStatusView: '', // 阅卷状态
	  validFenZhiList:[],
	  yjStatus:'',
	  imgShowHeight:0,
	  imgShowWidth:0,
    }
  },
  watch: {
    screenHeight(val) {
      // 为了避免频繁触发resize函数导致页面卡顿，使用定时器
      if (!this.timer) {
        // 一旦监听到的screenWidth值改变，就将其重新赋给data里的screenWidth
        this.screenHeight = val
        this.timer = true
        const that = this
        setTimeout(function() {
          // 打印screenWidth变化的值
          // console.log(that.screenHeight);
          that.timer = false
        }, 400)
      }
    },
    dataF() {
      this.dataF.length === this.tihaoArray.length
        ? (this.entFn = false)
        : (this.entFn = true)
    },
    input() {
      this.input == 'undefined' || this.input === ''
        ? (this.entFn = true)
        : (this.entFn = false)
    }
  },
  	 activated() {
			console.log('我这个页面显示就会执行');
			//阅卷题组信息
			this.sel_xm=this.$route.query.xm;
			this.sel_sb=this.$route.query.subject;
			this.sel_tizu=this.$route.query.tizu;

			const that = this
			window.onresize = () => {
				return (() => {
					window.screenHeight = document.body.clientHeight
					that.screenHeight = window.screenHeight-80
					that.screenWidth = window.screenWidth-100
				})()
			}
				this.selTizu();
	},
  mounted: function() {
	this.reload()
	console.log('hello mounted')
    const that = this
    // 阅卷题组信息
    that.sel_xm = that.$route.query.xm
    that.sel_sb = that.$route.query.subject
    that.sel_tizu = that.$route.query.tizu

	const elem = document.getElementById('panzoom-element')
	const panzoom = Panzoom(elem, {
  maxScale: 2,
  minScale:0.5,
  step:0.2
	})
	elem.parentElement.addEventListener('wheel', panzoom.zoomWithWheel)

    window.onresize = () => {
      return (() => {
        window.screenHeight = document.body.clientHeight
        that.screenHeight = window.screenHeight - 80
      })()
    }

    window.onkeyup = function(e) {
      let key
      var keyCode = window.event ? e.keyCode : e.which

      if (keyCode === 13 && that.input) {
        key = 'Ent'
        that.scoreSave(key)
      } else if (keyCode === 65 || keyCode === 33) {
        key = 'Last'
        that.backLast(key)
      } else if (keyCode === 68 || keyCode === 34) {
        key = 'Next'
        that.backLast(key)
      } else if (keyCode === 83 || keyCode === 106) {
        // s 83和*键
        key = 'MiScore'
        that.keycodeScore(key)
      } else if (keyCode === 87 || keyCode === 111) {
        // w 87和/键
        key = 'ycFn'
        that.openYcFn(key)
      }

      if (this.max_score < 10) {
        if (keyCode === 96) {
          key = '0'
          that.scoreSave(key)
        } else if (keyCode === 97) {
          key = '1'
          that.scoreSave(key)
        } else if (keyCode === 98) {
          key = '2'
          that.scoreSave(key)
        } else if (keyCode === 99) {
          key = '3'
          that.scoreSave(key)
        } else if (keyCode === 100) {
          key = '4'
          that.scoreSave(key)
        } else if (keyCode === 101) {
          key = '5'
          that.scoreSave(key)
        } else if (keyCode === 102) {
          key = '6'
          that.scoreSave(key)
        } else if (keyCode === 103) {
          key = '7'
          that.scoreSave(key)
        } else if (keyCode === 104) {
          key = '8'
          that.scoreSave(key)
        } else if (keyCode === 105) {
          key = '9'
          that.scoreSave(key)
        }
      }

      function removeTransition(event) {
        if (event.propertyName !== 'transform') return // 过滤其中一种事件
        event.target.classList.remove('act') // 移除高亮的样式
      }

      const button = document.querySelector(
        ".draggable [data-key='" + key + "']"
      )
     // button.classList.add('act')
     // button.addEventListener('transitionend', removeTransition)
    }

    
  },
  methods: {

	  
		 justifyImgWidth (e) {
			  // ratio = orgin width / origin height = 968 / 352 = 2.75
			   let imgSize = this.$refs['imgSize'].offsetHeight;
				console.log(imgSize);
				
				let imgHeight= this.$refs['imgSize'].naturalHeight
				console.log(imgHeight);

				let imgWidth= this.$refs['imgSize'].naturalWidth
				console.log(imgWidth);

				 
				 let imageRatio=imgWidth/imgHeight;
				 let screenRation=this.screenWidth/this.screenWidth;

				 if (imageRatio>screenRation)
				 {

				 }
				 else
				 {

				 }

				if (imgHeight>imgWidth)
				{
					this.imgShowHeight=this.screenHeight-10;
					this.imgShowWidth=(this.screenHeight-10)*imgWidth/imgHeight;

				}
				else
				{
					this.imgShowWidth=this.screenWidth-100;
					this.imgShowHeight=(this.screenWidth-100)*imgHeight/imgWidth;
					//如果高度超过屏幕高度
					if (this.imgShowHeight>this.screenHeight)
					{
						let ratio=this.screenHeight/this.imgShowHeight;
						this.imgShowHeight=ratio*this.imgShowHeight;
						this.imgShowWidth=ratio*this.imgShowWidth;


					}
					

				}

			this.logoWidth = 0
			},

    /**
     * 输入分数限制，保留一位小数，且小数为5
     * /(^0\.5$)|(^[1-9][0-9]*(\.[05])?$)/g
     * e.target.value
     */
    inputEnterFun(e) {
      const inputReg = /^\d*(\.?[05]{0,1})/g
      //this.input = this.input.match(inputReg)[0] || null
      //this.dataF = this.dataF.match(inputReg)[0] || null
    },
    tipsSus() {
      this.$message({
        showClose: true,
        message: '回评结束，进入正常阅卷!',
        type: 'success'
      })
    },
    tipsWarn() {
      this.$message({
        showClose: true,
        message: '无可评试卷',
        type: 'warning'
      })
    },

    keycodeScore(e) {
      this.visible = !this.visible
    },

    // 虚拟键盘点击
    maxScoreFn(e) {
      const curDK = e.currentTarget.dataset.key
      if (this.isFenbu === false) {
        this.input = curDK
      } else {
        // 分步功能
        for (let i = 0, ii = this.tihaoArray; i < ii.length; i++) {
          if (typeof this.dataF[i] === 'undefined' || this.dataF[i] === '') {
            this.$set(this.dataF, i, curDK)
            break
          }
          // 最后一个
          if (i === ii.length - 1 && !this.autoSave) {
            this.$set(this.dataF, i, curDK)
          }
        }

        if (this.tihaoArray.length === this.dataF.length) {
          this.entFn = false
        }
      }
    },

    updateFocusStatus(id) {
      const _this = this
      const children = _this.data[0].children

      if (children[id].focus) {
        children[id].focus = !children[id].focus
        return
      }

      children.map(n => {
        n.id != id ? (n.focus = false) : (n.focus = true)
      })
    },

    handleNodeClick(data) {
      const _this = this
      // console.log(data.id + ":" + data.focus);
      _this.updateFocusStatus(data.id)
    },

    // 选定题组
    selTizu() {
      //	alert(this.sel_xm+this.sel_sb+this.sel_tizu);
      this.$http
        .post(
          '/yj?op=selTizu',
          'xm=' +
            this.sel_xm +
            '&subject=' +
            this.sel_sb +
            '&tizu=' +
            this.sel_tizu
        )
        .then(function(response) {
          //	this.loginmsg=res.body;
          return response.json()
        })
        .then(function(json) {
          let arr_tihao = new Array()

          arr_tihao = json.fenbu_tihao.split(',')
          const tihaoLen = arr_tihao.length
          if (tihaoLen > 1) {
            arr_tihao.splice(tihaoLen - 1, 1)
            this.isFenbu = true
          }

          this.tihaoArray = arr_tihao

          this.fenzhiArray = json.fenbu_fenzhi.split(',')
          const fenzhiLen = this.fenzhiArray.length
          if (fenzhiLen > 1) {
            this.fenzhiArray.splice(fenzhiLen - 1, 1)
            // this.dataF = this.fenzhiArray;
          }

          this.buchang = json.buchang
          this.max_score = json.max_score
          this.yjcount = json.yjcount
          this.allsj_count = json.allsj_count
          this.yjStatusView = '已阅'
          this.is_disable = false

          // 数字生成数组
          this.maxScore = Object.keys(
            Array.from({ length: this.max_score + 1 })
          ).map(function(scoreKb) {
            return +scoreKb
          })

          
          // if (this.max_score > 9) {
          //   this.as_disable = true;
		  // }
		  console.log('hello validFenZhiList');
	    this.validFenZhiList=[];
			let  tmpi=0;
			this.validFenZhiList.push(tmpi.toString());

			let f_index=0;
			let f_count=this.max_score/this.buchang;
			let i=0;
			for ( i=1;i<=f_count;i++)
			{
				let  tmpi=i*this.buchang;
				this.validFenZhiList.push(tmpi.toString());
				console.log(i*this.buchang);


			}

			// 根据分数显示不同尺寸键盘
			if (f_count > 30) {
				this.maxKeycode = true
			}

          this.firstSj()
          // 获取题组相关信息  最大分值 步长等信息
        })
	},
	
		keySave(e) {
		let curDK = null;
		curDK = this.input = e.currentTarget.dataset.key;
		this.input=this.validFenZhiList[curDK];
		this.scoreSave();
	
		},

    // 自动提交分数
    autoScoreSave(e) {
      let curDK = null
      curDK = this.input = e.currentTarget.dataset.key
      this.scoreSave(curDK)
    },

    // 手动提交分数
    scoreSave() {
      let score = null
      if (this.isFenbu) {
        score = this.dataF.join(',')
        this.dataF = []
      } else {
      score = this.input
      score =score.toString()
		  if  (this.validFenZhiList.indexOf(score)==-1)
			{
			
					this.$message({
					showClose: true,
					message: '请输入正确的分值!只能输入 '+this.validFenZhiList,
					type: 'error'
					});

        console.log('输入的分值xxx',this.validFenZhiList);
				console.log('输入的分值',score);
				return;
			}
      }
      if (score > this.max_score) {
        this.$message({
          showClose: true,
          message: '分值超过最大值!',
          type: 'warning'
        })
        return
      }

      let isOk = false
      this.img_src = ''

      this.loading = true

      this.$http
        .post('/yj?op=scoreSave', 'score=' + score, {
          responseType: 'blob'
        })
        .then(function(response) {
          this.input = ''

          // 解析head
          const a = JSON.parse(response.headers.get('X-My-Header'))

          if (a != null) {
            if (a.returnMsg == 'nohuipingsj') {
              this.tipsSus()
            } else if (a.returnMsg == 'is over') {
              this.tipsWarn()
            } else {
              isOk = true
              this.input = a.score
              this.yjcount = a.yjcount
              // alert(a.score);
              return response.blob()
            }
          }
        })
        .then(function(blob) {
          if (isOk) {
            var urlCreator = window.URL || window.webkitURL
            var imageUrl = urlCreator.createObjectURL(blob)
            this.img_src = imageUrl
          } else {
            this.firstSj()
          }
        })

      this.loading = false
    },

    firstSj() {
      this.img_src = ''
      let isOk = false
      this.$http
        .get('/yj?op=firstSj', {
          responseType: 'blob'
        })
        .then(function(response) {
          // resolve to Blob
          const a = JSON.parse(response.headers.get('X-My-Header'))
          if (a != null) {
            if (a.returnMsg === 'is over') {
              this.tipsWarn()
            } else {
              isOk = true
              this.blBtn = true
              this.input = a.score

              this.yjcount = a.yjcount
              this.yjStatusView = '已阅'
              this.is_disable = false
              return response.blob()
            }
          }
        })
        .then(function(blob) {
          if (isOk) {
            var urlCreator = window.URL || window.webkitURL
            var imageUrl = urlCreator.createObjectURL(blob)
            this.img_src = imageUrl
          }
        })
    },

    // 异常提交询问
    openYcFn() {
      this.$confirm('此操作将提交异常试卷, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.yichangFn()
          this.$message({
            type: 'success',
            message: '异常提交成功!'
          })
        })
        
    },

    // 异常试卷
    yichangFn() {
      let isOk = false
      this.img_src = ''
      this.loading = true

      this.$http
        .post('/yj?op=yichang', '', {
          responseType: 'blob'
        })
        .then(function(response) {
          // 解析head
          const a = JSON.parse(response.headers.get('X-My-Header'))

          if (a != null) {
            isOk = true
            this.yjcount = a.yjcount
            return response.blob()
          }
        })
        .then(function(blob) {
          if (isOk) {
            var urlCreator = window.URL || window.webkitURL
            var imageUrl = urlCreator.createObjectURL(blob)
            this.img_src = imageUrl
          }
        })
      this.loading = false
    },

    // 回评试卷
    backLast(op) {
      let isOk = false
      this.img_src = ''
      this.$http
        .post('/yj?op=backLast', 'op=' + op, {
          responseType: 'blob'
        })
        .then(function(response) {
          // 解析head
          const a = JSON.parse(response.headers.get('X-My-Header'))
          if (a.returnMsg == 'ok') {
            isOk = true
            let arr_tihao = new Array()
            const strScore = a.score
            // let pos=strScore.indexOf(",");
            if (typeof strScore === 'string') {
              arr_tihao = strScore.split(',')
            }
            if (arr_tihao.length > 1) {
              this.dataF = arr_tihao
            } else {
              this.input = a.score
            }

            this.blBtn = false
            this.yjStatusView = '回评'
            this.blCount = a.yjcount
            this.yjcount = a.back_pos
            this.is_disable = false

            return response.blob()
          } else {
            this.tipsSus()
          }
        })
        .then(function(blob) {
          if (isOk) {
            // 解析返回图像
            var urlCreator = window.URL || window.webkitURL
            var imageUrl = urlCreator.createObjectURL(blob)
            this.img_src = imageUrl
          } else {
            this.firstSj()
          }
        })
    },

    post() {
      // 发送get请求
      this.$http
        .post(
          '/login',
          'username=' + this.username + '&password=' + this.password
        )
        .then(
          function(res) {
            // this.$set('msg', res.body);
            // document.write(res.body);
            this.loginmsg = res.body
          },
          function() {
            console.log('请求失败处理')
          }
        )
    },

    clickMe() {
      console.log(this.dataF)
      // 分步给分检测给分情况
      if (this.isFenbu) {
        //	alert(this.dataF.join(","))
        this.img_src = ''
        this.$http
          .post('/yj?op=scoreSave', 'score=' + this.dataF.join(','), {
            responseType: 'blob'
          })
          .then(function(response) {
            this.input = ''
            // resolve to Blob
            return response.blob()
          })
          .then(function(blob) {
            var urlCreator = window.URL || window.webkitURL
            var imageUrl = urlCreator.createObjectURL(blob)
            this.img_src = imageUrl
          })
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.bg-purple {
  background: #f0f9eb;
}

.bg-purple-light {
  background: #e5e9f2;
}

.grid-content {
  border-radius: 4px;
}

.kl-title,
.kl-numbar {
  position: relative;
  bottom: 0;
  height: 0;
  font-size: 0;
  z-index: 4;
}

.kl-title .el-row {
  position: absolute;
  width: 100%;
  text-align: center;
  padding: 12px;
  font-size: 18px;
  font-weight: 700;
  color: rgb(64, 158, 255);
  background: rgba(0, 21, 40, 0);
}

.vdr-parent {
  position: relative;
  .kl-exam-tips {
    display: block;
    height: 148px;
    width: 148px;
    text-align: center;
    position: absolute;
    padding: 16px;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    border-radius: 8px;
    -webkit-box-shadow: 0 0 8px rgba(0, 21, 41, 0.2);
    box-shadow: 0 0 8px rgba(0, 21, 41, 0.2);
  }
  .image-slot {
    display: inline-block;
    color: #f56c6c;
  }
  .el-icon-picture-outline {
    font-size: 6rem;
  }
}

.el-icon--right {
  margin-left: 0;
}
.el-icon--left {
  margin-right: 0;
}
span + .el-icon--right,
.el-icon--left + span {
  margin: 0;
}

.el-icon-t,
.el-icon--right,
.el-icon--left {
  font-size: 14px;
}

.kl-svg-exam {
  width: 100%;
  height: 100%;
  -webkit-transform-origin: center;
  transform-origin: center;
  position: relative;
  outline: none;
}

.kl-img-exam {
  width: 90%;
}

@media (min-width: 1441px) {
  .kl-img-exam {
    width: 80%;
  }
}
@media (min-width: 1601px) {
  .kl-img-exam {
    width: 70%;
  }
}
@media (min-width: 1921px) {
  .kl-img-exam {
    width: 60%;
  }
}

.kl-score-keycode {
  position: absolute;
  bottom: 61px;
  left: 0;
  width: auto;
  padding: 8px;
  text-align: left;
  background-color: #909399;
  border-radius: 8px;

  &.kl-max-keycode {
    width: 732px;
    left: -82px;
  }

  &.ty-step-score {
    bottom: 110px;
  }

  .el-button {
    width: 34px;
    text-align: center;
    margin: 4px;
    line-height: 1;
    padding: 8px 4px;
  }
}

.kl-score-tisp {

  color: #f56c6c;
  font-size: 48px;
  font-weight: bold;
  border-radius: 8px;
  text-align: center;
  width: auto !important;
  min-width: 100px;
  padding: 32px 12px;

  span {
    cursor: pointer;
    display: inline-block;
    min-width: 36px;
    text-align: center;
  }
  span + span::before {
    content: ",";
  }
}

// 动画控制
.kl-enter,
.kl-leave-to,
.kt-enter,
.kt-leave-to {
  opacity: 0;
}
.kl-enter-active,
.kl-leave-active {
  transition: opacity 1s;
}
.kt-enter-active,
.kt-leave-active {
  transition: opacity 3s;
}

// 自动提交控制
.kl-score-switch {
  .el-switch {
    background-color: #fff;
    padding: 4px;
    height: 28px;
    border-radius: 4px;
    margin: 4px 4px 0;
  }
}

.drag-handle {
  position: absolute;
  height: 60px;
  top: 0;
  width: 20px;
  cursor: move;
  &.l {
    left: 0;
  }
  &.r {
    right: 0;
  }
}
</style>
<style lang="scss">
.kl-numbar {
  width: 568px;
  margin: auto;
  .vdr {
    padding: 12px 12px 0;
    text-align: center;
    background-color:#909399;
    border-radius: 8px;
    border: none;
    -webkit-box-shadow: 0 0 8px rgba(0, 21, 41, 0.2);
    box-shadow: 0 0 8px rgba(0, 21, 41, 0.2);
  }
  .el-button-group + .el-input-group,
  .el-button + .el-button-group {
    margin-left: 6px;
    vertical-align: top;
  }
  // 评分功能
  .ty-score-bar {
    width: 208px;
    height: 38px;
    position: static;
    .el-button {
      color: #409eff;
    }
    .el-input__inner {
      height: 38px;
      line-height: 38px;
      padding: 0 8px;
      font-size: 18px;
    }
    &-btn {
      width: 186px;
      .el-input-group__prepend,
      .el-input-group__append {
        border-radius: 4px;
        width: 90px;
        padding: 0;
        .el-button {
          width: 100%;
        }
      }
    }

    input::-webkit-input-placeholder {
      opacity: 1;
      font-size: 12px;
    }

    /* Firefox 4-18 */
    input:-moz-placeholder {
      opacity: 1;
      font-size: 12px;
    }

    /* Firefox 19-50 */
    input::-moz-placeholder {
      opacity: 1;
      font-size: 12px;
    }

    /* - Internet Explorer 10–11
   - Internet Explorer Mobile 10-11 */
    input:-ms-input-placeholder {
      opacity: 1 !important;
      font-size: 12px !important;
    }

    /* Edge (also supports ::-webkit-input-placeholder) */
    input::-ms-input-placeholder {
      opacity: 1;
      font-size: 12px;
    }

    /* CSS Working Draft */
    input::placeholder {
      opacity: 1;
      font-size: 12px;
    }
  }

  .el-button {
    padding: 11px 12px;
  }

  //回评
  .el-button-group {
    vertical-align: top;
    .el-row {
      display: inline-block;
      font-size: 15px;
      float: left;
      color: #999;
      padding: 3px 4px 0;
      border: 1px solid #dcdfe6;
      border-width: 1px 0;
      height: 38px;
      width: 120px;
      background-color: #fff;
      margin-left: 1px;
    }
    .el-button {
      padding: 11px 8px;
    }
  }

  //帮助
  .el-badge {
    position: absolute;
    top: -6px;
    right: -8px;
    z-index: 3;
  }

  //回评/计数
  .kl-exam-count {
    display: block;
    span {
      padding: 0 4px;
      &:first-child {
        color: #409eff;
        font-weight: 700;
      }
    }
  }

  // 回评/任务/状态
  .kl-exam-mark {
    display: block;
    font-size: 12px;
    text-align: center;
    color: #333;
    margin-top: 2px;

    span {
      padding: 0 4px;
    }
  }

  // 分步
  .ty-step-by {
    background-color: rgba(0, 21, 40, 0.5);
    border-radius: 8px;
    height: 48px;
    padding: 6px 8px 0;
    width: 100%;
    font-size: 0;
    line-height: 1;
    position: absolute;
    top: -49px;
    left: 0;
    z-index: 1;

    &-list {
      height: 36px;
      display: inline-block;
      font-size: 14px;
      width: 40px;
      text-align: center;
      border: none;
    }
    &-list + .ty-step-by-list {
      margin-left: 1px;
    }
  }
}

.act {
  transform: scale(1.1);
  border-color: #ffc600;
  box-shadow: 0 0 10px #ffc600;
  color: #ffc600;
}

.kl-tooltip {
  line-height: 1.5;
}

.imgdiv{
       
        display: flex;
        justify-content: center;
        align-items: center;
    }
</style>
